<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue"

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  options: { type: Array, default: () => [] },
  placeholder: { type: String, default: "Все" },
  searchPlaceholder: { type: String, default: "Поиск…" }
})
const emit = defineEmits(["update:modelValue"])
const root = ref(null), open = ref(false), search = ref("")
const normalized = value => String(value)
const selectedSet = computed(() => new Set(props.modelValue.map(normalized)))
const selectedOptions = computed(() => props.options.filter(option => selectedSet.value.has(normalized(option.id))))
const filteredOptions = computed(() => {
  const tokens = search.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean)
  if (!tokens.length) return props.options
  return props.options.filter(option => {
    const searchableText = [option.name, option.id, option.search, ...(option.external_ids || [])].filter(value => value !== null && value !== undefined).join(" ").toLocaleLowerCase()
    return tokens.every(token => searchableText.includes(token))
  })
})
const summary = computed(() => {
  if (!props.modelValue.length) return props.placeholder
  if (props.modelValue.length === 1) return selectedOptions.value[0]?.name || props.modelValue[0]
  return `Выбрано: ${props.modelValue.length}`
})
function toggle(option) {
  const id = normalized(option.id)
  const next = selectedSet.value.has(id) ? props.modelValue.filter(value => normalized(value) !== id) : [...props.modelValue, option.id]
  emit("update:modelValue", next)
}
function clear() { emit("update:modelValue", []) }
function closeOnOutsideClick(event) { if (root.value && !root.value.contains(event.target)) open.value = false }
onMounted(() => document.addEventListener("click", closeOnOutsideClick))
onBeforeUnmount(() => document.removeEventListener("click", closeOnOutsideClick))
</script>

<template>
  <div ref="root" class="search-multiselect" :class="{open}">
    <button type="button" class="search-multiselect-trigger" :aria-expanded="open" @click="open=!open;search=''">
      <span :class="{placeholder:!modelValue.length}">{{ summary }}</span><span class="chevron">⌄</span>
    </button>
    <div v-if="open" class="search-multiselect-menu">
      <div class="search-multiselect-search"><input v-model="search" :placeholder="searchPlaceholder" type="search" autofocus><button v-if="modelValue.length" type="button" @click="clear">Очистить</button></div>
      <div class="search-multiselect-options">
        <label v-for="option in filteredOptions" :key="option.id" :class="{selected:selectedSet.has(normalized(option.id))}">
          <input type="checkbox" :checked="selectedSet.has(normalized(option.id))" @change="toggle(option)">
          <span><strong>{{ option.name }}</strong><small v-if="option.meta">{{ option.meta }}</small></span>
        </label>
        <div v-if="!filteredOptions.length" class="search-multiselect-empty">Ничего не найдено</div>
      </div>
    </div>
  </div>
</template>
